import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { isSentView } from 'find-and-filter-data/views-schema/public';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import getThreadUrl from '../../urls/getThreadUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailSentAlert = ({
  threadId
}) => {
  const currentView = useCurrentView();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.alerts.EMAIL_SENT_ALERT.message"
    }), !isSentView(currentView) && /*#__PURE__*/_jsx(Button, {
      use: "link",
      external: true,
      href: getThreadUrl(threadId),
      marginInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.alerts.EMAIL_SENT_ALERT.button"
      })
    })]
  });
};
EmailSentAlert.displayName = 'EmailSentAlert';
export default EmailSentAlert;